import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import CoursePlayer from "@/pages/CoursePlayer";
import AuthCallback from "@/pages/AuthCallback";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Certificate from "@/pages/Certificate";
import AdminDashboard from "@/pages/AdminDashboard";
import { Toaster } from "sonner";

function AppRouter() {
  const location = useLocation();
  // Synchronous check (NOT in useEffect) — handles OAuth callback before any other route logic
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/learn/:lessonId" element={<CoursePlayer />} />
      <Route path="/checkout/success" element={<CheckoutSuccess />} />
      <Route path="/certificate" element={<Certificate />} />
      <Route path="/admin" element={<AdminDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
